/*
	Journey Step Progress
	Show which step of the process we're in (Selecting Art 1-5)
	If a step does have a piece of selected art, show it

	Current Step (1-5) is active
	Each step shows a preview of the selected art
	Show the selected theme

	Actions:
		- Allow the user to change their theme
		- Allow the user to jump back to a previous step
 */

/*
	This is meant for the top of the page -- which step are we on?
		1 -- select them
		2 -- buid a journey
		3 -- print your guide
		4 -- explore the museum
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import JourneyStepProgressPanel from './JourneyStepProgressPanel'
import { resetToHome } from '../../actions/journey-actions'
import {
   getSelectedJourney,
   getJourneyStepsForSelectedJourney,
} from '../../selectors/journeyState-selectors'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';
import '../../css/JourneyStepProgress.css'
import logo from '../../assets/logo-mini-nav.png'

const JourneyStepProgress = (props) => {
  //if (props.show) {
    return (
       <span>
         <div className={'journey-nav-progress-bar'}>
            {props.getJourneyStepsForSelectedJourney && props.getJourneyStepsForSelectedJourney.map( j => (
               <JourneyStepProgressPanel key={`journey-step-${j}`} galleryId={props.galleryId} journeyStep={j} />
            ))}
         </div>
         <div className={'journey-nav-theme-bar'} style={{'display': 'none'}}>
            <img src={logo} alt="Mini Logo" />
            <div className={'theme-name'}>
               <span className={'medium-3'}>{props.getSelectedJourney && props.getSelectedJourney.title}</span>
            </div>
            <Hammer onTap={() => props.resetToHome(props.galleryId)} options={tapOptions} >
              <button className={'change-theme small-3'}>CHANGE THEME</button>
            </Hammer>
            <button className={'credit small-3'}>CREDIT</button>
         </div>
      </span>
   )
}

const mapStateToProps = (state, ownProps) => ({
   getSelectedJourney: getSelectedJourney(state, ownProps),
   getJourneyStepsForSelectedJourney: getJourneyStepsForSelectedJourney(state, ownProps),
   ...ownProps
})

const mapDispatchToProps = dispatch => bindActionCreators({
   resetToHome,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyStepProgress)


// WEBPACK FOOTER //
// ./src/components/JourneyStep/JourneyStepProgress.js